export function isString(arg: any): arg is string {
    return typeof arg === 'string';
}

export function isFile(arg: any): arg is File {
    return arg instanceof File;
}
